import { jsx as _jsx } from "react/jsx-runtime";
// src/pages/StoreRedirectPage/StoreRedirectPage.tsx
import { useEffect } from "react";
export default function StoreRedirectPage() {
    useEffect(function () {
        var userAgent = navigator.userAgent;
        var isXiaomi = /xiaomi|redmi|poco|\bmi\b/i.test(userAgent);
        console.log(userAgent, 'userAgent');
        if (isXiaomi) {
            window.location.href = "https://play.google.com/store/apps/details?id=com.efir.efirApplicationOrg";
        }
        else if (/iPad|iPhone|iPod/.test(userAgent)) {
            window.location.href = "https://apps.apple.com/am/app/ego-mobile/id6736775121";
        }
        else if (/android/i.test(userAgent)) {
            window.location.href = "https://play.google.com/store/apps/details?id=com.efir.efirApplicationOrg";
        }
        else {
            window.location.href = "https://apps.apple.com/am/app/ego-mobile/id6736775121";
        }
    }, []);
    return (_jsx("div", { style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            backgroundColor: '#f5f5f5',
            padding: '20px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
        } }));
}
